import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionService } from '../../shared/session-service/session.service';
import { API_URL } from '../../shared/constants/apiurl-constants';
import { CreateClientUserModel } from '../../shared/models/create-client-user.model';
import { UpdateUserRequest } from '../../shared/models/update-user-request.model';


@Injectable({
  providedIn: 'root',
})
export class AdminClientUsersService {
  userListRefresh = new BehaviorSubject({});
  userList = this.userListRefresh.asObservable();
  isInsert = new BehaviorSubject({});
  isInsertData = this.isInsert.asObservable();
  selectedUserDetails: any;
  clientId: any;
  isClient: boolean = false;

  constructor(public sessionService: SessionService) {}

  refreshTable() {
    this.userListRefresh.next(true);
  }

  CreateUser(userData: CreateClientUserModel): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.ADD_USER, userData);
  }

  GetUser(clientId: number, isManageClientUser = false): Observable<any> {
    return this.sessionService.apiUrlGet(
      API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientId + '&isManageClientUser='+ isManageClientUser,
    );
  }

  deleteUser(clientUserId: number): Observable<any> {
    let deleteClientUserRequest = { clientUserId: clientUserId };
    return this.sessionService.apiUrlPost(API_URL.CLIENT.DELETE_USER, deleteClientUserRequest);
  }

  setFunctionTypeAndData(
    isClient: boolean = false,
    isInsert: boolean,
    userData: any = null,
  ) {
    this.selectedUserDetails = userData;
    this.isClient = isClient;
    this.isInsert.next(isInsert);
  }

  GetClients() {
    return this.sessionService.apiUrlGet(API_URL.GETCLIENTNAMES);
  }
  CheckEmail(emailId: string) {
    let emailInput = {email: emailId};
    return this.sessionService.apiUrlPost(API_URL.CLIENT.CHECK_EMAIL, emailInput);
  }
  CheckSignInName(signInName: string) {
    let signInNameInput = {signInName: signInName};
    return this.sessionService.apiUrlPost(
      API_URL.CLIENT.CHECK_SIGN_IN_NAME,
      signInNameInput,
    );
  }

  updateClientUser(userData: UpdateUserRequest): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.UPDATE_USER, userData);
  }

  EditNickName(UpdateData: any): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.UPDATE_NICKNAME, UpdateData);
  }

  getClientusersforAdmin() {
    return this.sessionService.apiUrlGet(API_URL.GETUSERSFORCLIENTADMIN);
  }

  provisionFailedUsers(clientId: number): Observable<any> {
    return this.sessionService.apiUrlGet(API_URL.CLIENT.PROVISION_FAILED_USERS + '?clientId=' + clientId);
  }

}
